import { render, staticRenderFns } from "./HistorySlider.vue?vue&type=template&id=e8090f46&"
import script from "./HistorySlider.js?vue&type=script&lang=js&"
export * from "./HistorySlider.js?vue&type=script&lang=js&"
import style0 from "./HistorySlider.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports